import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.scss']
})
export class VideoDialogComponent {
  public video?: string;
  downloading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { name: string },
    private dialogRef: MatDialogRef<VideoDialogComponent>,
  ) {
    const defaultValues = {
      video: null,
    };
    const values: any = {
      ...defaultValues,
      ...data,
    };

    this.video = values.video;
  }

  closeDialog() {
    this.dialogRef.close({data: 'confirmation'});
  }
}
